<template>
  <v-container fluid>
    <SidebarNavigation />

    <v-card>
      <v-row class="pt-3 px-1" justify="start" align="top">
        <v-col cols="auto" style="max-width: 180px">
          <v-menu
            v-model="pagination.startMenu"
            :close-on-content-click="false"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="pagination.startDate"
                label="Tanggal Awal"
                readonly
                dense
                outlined
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="pagination.startDate"
              @input="onDateChange('start')"
              locale="id"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="auto" style="max-width: 180px">
          <v-menu
            v-model="pagination.endMenu"
            :close-on-content-click="false"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="pagination.endDate"
                label="Tanggal Akhir"
                readonly
                dense
                outlined
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="pagination.endDate"
              @input="onDateChange"
              locale="id"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="auto" style="max-width: 180px">
          <v-text-field
            v-model="pagination.search"
            label="Search"
            append-icon="mdi-magnify"
            dense
            hide-details
            outlined
            @input="debouncedSearch"
          ></v-text-field>
        </v-col>

        <v-col cols="auto">
          <v-btn color="primary" @click="exportToExcel"> Download </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-data-table
            mobile-breakpoint="0"
            fixed-header
            dense
            class="elevation-5"
            :headers="tableHeaders"
            :items="suggestionsList"
            :items-per-page.sync="pagination.itemsPerPage"
            :page.sync="pagination.page"
            :sort-by="pagination.sortBy"
            :sort-desc="pagination.sortDesc"
            :loading="isLoading"
            :server-items-length="totalSuggestions"
            item-key="id"
            @update:page="updateQuery('page', $event)"
            @update:items-per-page="updateQuery('itemsPerPage', $event)"
            @update:sort-by="updateQuery('sortBy', $event)"
            @update:sort-desc="updateQuery('sortDesc', $event)"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>
                    {{ item.created_by_name }}
                  </td>
                  <td>
                    {{ item.corporate_name }}
                  </td>
                  <td>
                    {{ item.site_name }}
                  </td>
                  <td>
                    {{ item.nik }}
                  </td>
                  <td>
                    {{ item.division_name }}
                  </td>
                  <td>
                    {{ item.created_on }}
                  </td>
                  <td>
                    {{ item.suggestion_category_name }}
                  </td>
                  <td>
                    {{ item.title }}
                  </td>
                  <!-- <td>
                    {{ item.description }}
                  </td> -->
                  <!-- <td>
                    {{ item.suggestions }}
                  </td> -->
                  <!-- <td>
                    {{ item.need_cost }}
                  </td> -->
                  <td>
                    {{ item.benefit }}
                  </td>
                  <td>
                    {{ item.noted_cost }}
                  </td>
                  <td>
                    {{ item.perhitungan }}
                  </td>
                  <td>{{ item.screening_ide }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";
import exceljs from "exceljs";
import { saveAs } from "file-saver";
import { getLast30Days, dateFormatDmy } from "@/utils/date";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      statusOptions: [
        { status: "all", status_name: "All" },
        { status: "Waiting Approval", status_name: "Waiting Approval" },
        { status: "Need To Analysis", status_name: "Need To Analysis" },
        { status: "Approved Atasan", status_name: "Approved Atasan" },
        {
          status: "Approved Operation Excellence & Improvement",
          status_name: "Approved Operation Excellence & Improvement",
        },
        { status: "implemented", status_name: "Implemented" },
        { status: "rejected", status_name: "Rejected" },
      ],
      statusOsOptions: [
        { status_os: "All", status_name: "all" },
        {
          status_os: "Outsourcing",
          status_name: "1",
        },
        {
          status_os: "Non Outsourcing",
          status_name: "0",
        },
      ],
      siteOptions: [],
      awsObjectUrl: process.env.VUE_APP_AWS_OBJECT_URL,
      awsPath: process.env.VUE_APP_AWS_PATH,
      tableHeaders: [
        { text: "Nama", align: "center", value: "created_by_name" },
        { text: "Perusahaan", align: "center", value: "corporate_name" },
        { text: "Lokasi Kerja", align: "center", value: "site_name" },
        { text: "NIK", align: "center", value: "nik" },
        { text: "Bagian", align: "center", value: "division_name" },
        { text: "Tanggal Pengajuan", align: "center", value: "created_on" },
        {
          text: "Jenis Tujuan/Manfaat/Keuntungan",
          align: "center",
          value: "suggestion_category_name",
        },
        { text: "Judul Suggestion System", align: "center", value: "title" },
        // {
        //   text: "Latar Belakang dan Uraian Masalah",
        //   align: "center",
        //   value: "description",
        // },
        // {
        //   text: "Solusi Masalah (Usulan Tindakan Penanggulangan):",
        //   align: "center",
        //   value: "suggestions",
        // },
        // {
        //   text: "Simulasi Benefit (Rp) *) Jika Ada",
        //   align: "center",
        //   value: "benefit",
        // },
        {
          text: "Apakah ESS ini membutuhkan biaya",
          align: "center",
          value: "noted_cost",
        },
        {
          text: "Keterangan Biaya",
          align: "center",
          value: "noted_cost",
        },
        {
          text: "Apakah ESS ini ada simulasi perhitungannya",
          align: "center",
          value: "perhitungan",
        },
        {
          text: "Screening Ide",
          align: "center",
          value: "screening_ide",
        },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: true,
        startMenu: false,
        endMenu: false,
        startDate: getLast30Days().start,
        endDate: getLast30Days().end,
        search: "",
        status: null,
        statusOs: null,
        siteId: null,
      },
      totalSuggestions: 0,
      suggestionsList: [],
      isLoading: false,
      isDialogOpen: false,
      pathDocumentList: [],
      exportColumns: [
        { key: "created_by_name", label: "Nama" },
        { key: "corporate_name", label: "Perusahaan" },
        { key: "site_name", label: "Lokasi Kerja" },
        { key: "nik", label: "NIK" },
        { key: "division_name", label: "Bagian" },
        { key: "created_on", label: "Tanggal Pengajuan" },
        {
          key: "suggestion_category_name",
          label: "Jenis Tujuan/Manfaat/Keuntungan",
        },
        { key: "title", label: "Judul Suggestion System" },
        { key: "description", label: "Latar Belakang dan Uraian Masalah" },
        {
          key: "suggestions",
          label: "Solusi Masalah (Usulan Tindakan Penanggulangan)",
        },
        { key: "need_cost", label: "Simulasi Benefit (Rp) *) Jika Ada" },
        { key: "benefit", label: "Apakah ESS ini membutuhkan biaya" },
        { key: "noted_cost", label: "Keterangan Biaya" },
        {
          key: "perhitungan",
          label: "Apakah ESS ini ada simulasi perhitungannya",
        },
        { key: "screening_ide", label: "Screening Ide" },
      ],
    };
  },
  methods: {
    fetchSites() {
      api
        .get("/sites?corporateId=2")
        .then(({ data }) => {
          this.siteOptions = data.data.data;
          this.siteOptions.unshift({
            mst_site_id: "all",
            mst_site_name: "All",
          });
          this.selectedSiteId = "all";
        })
        .catch((error) => {
          console.error("Error fetching sites:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    async fetchReportHistory() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || false,
        status: query.status || this.pagination.status || "all",
        statusOs: query.statusOs || this.pagination.statusOs || "all",
        siteId: query.siteId || this.pagination.siteId || "all",
        startDate: query.startDate || this.pagination.startDate,
        endDate: query.endDate || this.pagination.endDate,
      };

      await api
        .get("/report/history", { params })
        .then(({ data }) => {
          this.suggestionsList = data.data.data;
          console.log(this.suggestionsList);

          this.totalSuggestions = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    async exportToExcel() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: 1,
        limit: -1,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || false,
        status: query.status || this.pagination.status || "all",
        statusOs: query.statusOs || this.pagination.statusOs || "all",
        siteId: query.siteId || this.pagination.siteId || "all",
        startDate: query.startDate || this.pagination.startDate,
        endDate: query.endDate || this.pagination.endDate,
      };

      await api
        .get("/report/history", { params })
        .then(({ data }) => {
          const dataExcel = data.data.data;

          // Buat workbook dan worksheet
          const workbook = new exceljs.Workbook();
          const worksheet = workbook.addWorksheet("Data Export");

          // Tambahkan header ke worksheet
          const headerRow = this.exportColumns.map((col) => col.label);
          worksheet.addRow(headerRow);

          // Tambahkan data ke worksheet
          dataExcel.forEach((item) => {
            worksheet.addRow(this.exportColumns.map((col) => item[col.key]));
          });

          // Styling header (Bold + Background Color + Center)
          worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: "center", vertical: "middle" };
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFFF00" }, // Kuning
            };
          });

          // Styling semua sel agar center
          worksheet.eachRow((row) => {
            row.eachCell((cell) => {
              cell.alignment = { horizontal: "center", vertical: "middle" };
            });
          });

          // Auto width untuk setiap kolom
          worksheet.columns.forEach((column) => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
              maxLength = Math.max(
                maxLength,
                cell.value ? cell.value.toString().length : 10
              );
            });
            column.width = maxLength + 2; // Tambahkan padding
          });

          // Simpan file Excel
          workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(
              blob,
              `Report_history_(${dateFormatDmy(
                this.pagination.startDate
              )}_sampai_${dateFormatDmy(this.pagination.endDate)}).xlsx`
            );
          });
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      console.log(query);
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.pagination.startDate = query.startDate || this.pagination.startDate;
      this.pagination.endDate = query.endDate || this.pagination.endDate;
      this.pagination.status = query.status || "all";
      this.pagination.statusOs = query.statusOs || "all";
      this.pagination.siteId = parseInt(query.siteId) || "all";
    },
    updateQuery(key, value) {
      // console.log(key);
      // console.log(value);
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
    getToday() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Bulan mulai dari 0
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`; // Format ISO
    },
    onDateChange(param) {
      if (param === "start") {
        this.updateQuery("startDate", this.pagination.startDate); // Update startDate
      } else {
        this.updateQuery("endDate", this.pagination.endDate); // Update endDate
      }
    },
  },
  watch: {
    pagination: {
      handler: "fetchReportHistory",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },
  mounted() {
    store.commit("setTitle", "History");
    this.fetchSites();
    this.fetchReportHistory();
    this.updatePagination(this.$route.query);
  },
};
</script>

<style scoped>
.v-data-table td:nth-child(5),
td:nth-child(6),
td:nth-child(7) {
  text-align: center;
}
</style>
